import React, { useState, useContext } from 'react';
import classes from '../index.module.scss';
import { SearchContext } from '../../../context/Search';
import moment from 'moment';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import DeleteReport from '../../ScheduleSms/DeleteReport'

const ScheduleSmsTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId('');
  }

  const onDeleteReport = (e, id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
    e.preventDefault();
  }
  
  return (
    <>
      {
        searchedData.map(item => {
          const { template_id, is_active, last_triggered, recurrence_frequency, recurrence_interval, scheduled_send_time, template_title, created } = item; 
          const created_date = moment(created).format('MM/DD/YYYY hh:mm A');
          const last_triggered_date = last_triggered ? moment(last_triggered).format('MM/DD/YYYY hh:mm A'): 'Never';
          const scheduled_send_time_date = scheduled_send_time ? moment(scheduled_send_time).format('MM/DD/YYYY hh:mm A'): 'Never';
          const is_active_data = !!is_active;
          const selectValue={"ONE_TIME": "Onetime", "DAY": "Daily", "WEEK": "Weekly", "MONTH": "Monthly", "YEAR": "Yearly"};   

          return (
            <tr 
              key={template_id}
            >
              <td className={`${classes.Title_Bold} ${classes.Vertical_Middle}`}>{created_date}</td>
              <td className={`${classes.Title_Bold} ${classes.Vertical_Middle}`}>{template_title || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{recurrence_interval || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle} ${classes.Vertical_Middle_Email}`}>{selectValue[recurrence_frequency] || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{last_triggered_date || "Never"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{scheduled_send_time_date || "Never"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`} style={{padding: '0.1rem', textAlign: 'center'}}>
                <span 
                  className={`${is_active_data ? "responded" : "not_responded"} general`}
                >
                  {is_active_data ? "Active" : "Not Active"}
                </span>
              </td>
              <td className={classes.Table_Options} style={{display: 'flex'}}>
                <Link
                  to={`/sms-schedule?template_id=${template_id}&type=sms`}
                  className="btnSizes filledBtn"
                >
                  View
                </Link>
                <Link
                  to={`/update-sms-schedule?template_id=${template_id}&type=sms`}
                  className="btnSizes transparentBtn ml-2"
                >
                  Edit
                </Link>
                <HashLink
                  onClick={(e) => onDeleteReport(e, template_id)}
                  to='#'
                  className="btnSizes defaultBtn ml-2"
                  smooth
                >
                  Delete
                </HashLink>
              </td>
            </tr> 
          )
        })
      }

    { showDeleteModal && <DeleteReport template_id={deleteId} closeDeleteModal={closeDeleteModal} showDelete={showDeleteModal}/> }

    </>
  )
}

export default ScheduleSmsTableBody;
 